import React, { useEffect } from 'react'
import WebFont from 'webfontloader';
import Moment from 'react-moment';
import moment from 'moment';
// eslint-disable-next-line
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { Container, Row, Card, Button, Table, Dropdown, Badge, Modal, Form, ListGroup, Col, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight, faCalendarAlt, faCoins, faDownload, faEllipsisV, faEye, faFilePdf, faGavel, faPlusCircle, faSchool, faTrash } from '@fortawesome/free-solid-svg-icons'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import NavBar from "../navbar/Navbar";
import { get, post } from '../../../controllers/endpoints.controller';
import { getUserToken, logout } from '../../../controllers/user.controller';
import { removeTildes } from '../../../tools/chains';
import { data } from 'jquery';



export default function NewDebtStep1() {

    const PAGE_TITLE = "Nueva cita";
    const PAGE_ICON = faCalendarAlt;

    const [showSearchCustomerModal, setShowSearchCustomerModal] = React.useState(false);
    const [showSearchDefendantModal, setShowSearchDefendantModal] = React.useState(false);
    const [showSearchStudentModal, setShowSearchStudentModal] = React.useState(false);
    const [showLawerModal, setShowLawerModal] = React.useState(false);
    const [customers, setCustomers] = React.useState([]);
    const [selectedCustomer, setSelectedCustomer] = React.useState(null);
    const [defendants, setDefendants] = React.useState([]);
    const [selectedDefendant1, setSelectedDefendant1] = React.useState(null);
    const [selectedDefendant2, setSelectedDefendant2] = React.useState(null);
    const [selectedDefendant3, setSelectedDefendant3] = React.useState(null);
    const [selectedStudent1, setSelectedStudent1] = React.useState(null);
    const [selectedStudent2, setSelectedStudent2] = React.useState(null);
    const [selectedStudent3, setSelectedStudent3] = React.useState(null);
    const [actualDefendant, setActualDefendant] = React.useState(0);
    const [actualStudent, setActualStudent] = React.useState(0);
    const [lawers, setLawers] = React.useState([]);
    const [selectedLawer, setSelectedLawer] = React.useState(0);
    const [defendantLawer, setDefendantLawer] = React.useState({});
    const [canNext, setCanNext] = React.useState(false);
    const [date, setDate] = React.useState(new Date());
    const [color, setColor] = React.useState("#0D72B5");

    const [showNewCustomerDefendantModal, setShowNewCustomerDefendantModal] = React.useState(false);
    const handleCloseNewCustomerDefendantModal = () => { setShowNewCustomerDefendantModal(false); };
    const handleShowNewCustomerDefendantModal = (isCustomer) => {
        handleCloseSearchCustomerModal();
        setSelectedIsCustomer(isCustomer);
        getProvinces();
        getGenders();

        setShowNewCustomerDefendantModal(true);
    };

    const [stepData, setStepData] = React.useState({});

    const [provinces, setProvinces] = React.useState([]);
    const [selectedProvince, setSelectedProvince] = React.useState("");
    const [genders, setGenders] = React.useState([]);
    const [selectedGenders, setSelectedGender] = React.useState(0);
    const [selectedIsBusiness, setSelectedIsBusiness] = React.useState(false);
    const [selectedIsCustomer, setSelectedIsCustomer] = React.useState(false);
    const [personTypes, setPersonTypes] = React.useState(["Persona física", "Persona jurídica"]);

    const handleProvince = (event) => {
        setSelectedProvince(event.target.value);
    };

    const handleGender = (event) => {
        setSelectedGender(event.target.value);
    };

    const handleColor = (event) => {
        setColor(event.target.value);
    };

    const handleIdentifier = (event) => {
        getIdentifier(event.target.value)
    };

    const handleType = (event) => {
        setSelectedIsBusiness(event.target.value == "Persona jurídica")
    };


    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Roboto:100,300,400']
            }
        });

        document.title = `Plagamix - ${PAGE_TITLE}`;
        registerLocale('es', es);

    }, []);

    const getIdentifier = async function (data) {
        const chain = {
            chain: data
        }
        const req = await post('/others/identifier', getUserToken(), chain);
        const res = await req.json();

        if (req.status === 200) {
            document.getElementById('textIdentifier').value = res.chain;
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
            console.log(res)
        }
    }

    const getProvinces = async function () {
        const req = await get('/others/provinces', getUserToken());
        const res = await req.json();

        if (req.status === 200) {
            setProvinces(res);
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
        }
    }

    const getGenders = async function () {
        const req = await get('/others/genders', getUserToken());
        const res = await req.json();

        if (req.status === 200) {
            setGenders(res);
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
        }
    }

    const handleDate = (event) => {
        setDate(event);
    };

    const handleCloseSearchCustomerModal = () => {
        setShowSearchCustomerModal(false);
    };

    const handleOpenSearchCustomerModal = () => {
        setShowSearchCustomerModal(true);
    };

    const handleCloseSearchDefendantModal = () => {
        setShowSearchDefendantModal(false);
    };

    const handleOpenSearchDefendantModal = (index) => {
        setActualDefendant(index)
        setShowSearchDefendantModal(true);
    };

    const handleCloseSearchStudentModal = () => {
        setShowSearchStudentModal(false);
    };

    const handleOpenSearchStudentModal = (index) => {
        setActualStudent(index)
        setShowSearchStudentModal(true);
    };

    const handleCloseLawerModal = () => {
        setShowLawerModal(false);
    };

    const handleProcessLawerModal = () => {

        setShowLawerModal(false);
    };

    const handleOpenLawerModal = () => {
        setShowLawerModal(true);
    };

    const handleCustomerSelected = (index, isBusiness) => {
        for (let c of customers) {
            if (c.id == index && c.isBusiness == isBusiness) {
                setSelectedCustomer(c);
                document.getElementById('textCustomer').value = c.isBusiness == true ? (`${c.cuit.length > 1 ? `CUIT ${c.cuit} - ` : ""}${c.legalName}`) : `${c.dni.length > 1 ? `DNI ${c.dni} - ` : ""}${c.surname.toUpperCase()}, ${c.name}`;
                setCustomers([]);
                handleCloseSearchCustomerModal();
                setCanNext(checkStep(false, true, false));
            }
        }
    };

    const checkStep = (employee, customer, defendant, student) => {
        if (employee) {
            if (selectedCustomer) {
                if (selectedStudent1) {
                    return true;
                }
            }
        } else if (customer) {
            if (selectedLawer) {
                if (selectedStudent1) {
                    return true;
                }
            }
        } else if (student) {
            if (selectedLawer) {
                if (selectedCustomer) {
                    return true;
                }
            }
        }
        return false;
    }

    const handleDefendantSelected = (index, isBusiness) => {
        for (let d of defendants) {
            if (d.id == index && d.isBusiness == isBusiness) {
                switch (actualDefendant) {
                    case 1:
                        setSelectedDefendant1(d);
                        break;
                    case 2:
                        setSelectedDefendant2(d);
                        break;
                    case 3:
                        setSelectedDefendant3(d);
                        break;
                }
                document.getElementById(`textDefendant${actualDefendant}`).value = d.isBusiness == true ? (`${d.cuit.length > 1 ? `CUIT ${d.cuit} - ` : ""}${d.legalName}`) : `${d.dni.length > 1 ? `DNI ${d.dni} - ` : ""}${d.surname.toUpperCase()}, ${d.name}`;
                setDefendants([]);
                handleCloseSearchDefendantModal();
                //setCanNext(checkStep(false, false, true));
            }
        }
    };

    const handleProcessStudentModal = () => {
        const s = {
            name: document.getElementById('studentName').value,
            surname: document.getElementById('studentSurname').value,
            dni: document.getElementById('studentDni').value
        }
        switch (actualStudent) {
            case 1:
                setSelectedStudent1(s);
                break;
            case 2:
                setSelectedStudent2(s);
                break;
            case 3:
                setSelectedStudent3(s);
                break;
        }
        document.getElementById(`textStudent${actualStudent}`).value = `${s.dni.length > 1 ? `DNI ${s.dni} - ` : ""}${s.surname.toUpperCase()}, ${s.name}`;
        handleCloseSearchStudentModal();
        setCanNext(checkStep(false, false, false, true));
    };

    const handleSearchCustomers = async (event) => {
        if (event.target.value.length > 2) {
            const chain = {
                chain: event.target.value
            };
            const req = await post(`/customers/search`, getUserToken(), chain);
            const res = await req.json();

            if (req.status === 200) {
                setCustomers(res)
            } else {
                alert(res.message);
                console.log(res)
            }
        } else {
            setCustomers([])
        }
    };

    const handleSearchDefendants = async (event) => {
        if (event.target.value.length > 2) {
            const chain = {
                chain: event.target.value
            };
            const req = await post(`/defendants/search`, getUserToken(), chain);
            const res = await req.json();

            if (req.status === 200) {
                setDefendants(res)
            } else {
                alert(res.message);
                console.log(res)
            }
        } else {
            setDefendants([])
        }
    };








    return (
        <div className='p-0' style={{ fontFamily: 'Roboto' }}>
            <style>{'body {background-color: #EBEBEB !important;}'}</style>
            <NavBar />

            <div style={{ height: 300, background: '#FAFAFA' }}>
                <Container>
                    <Row style={{ paddingTop: 10 }}>
                        <table className='w-75' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                            <tr>
                                <td style={{ fontSize: 45, fontWeight: 300 }}>
                                    <p className='m-0' style={{ color: '#A0A0A0', fontSize: 25, fontWeight: 300 }}>Cita</p>
                                    <p className='m-0' style={{ color: '#A0A0A0', fontSize: 45, fontWeight: 300 }}>Tostado Cafe Club</p>
                                </td>
                                <td style={{ fontSize: 140, width: 150 }}>
                                    <FontAwesomeIcon icon={PAGE_ICON} style={{ fontSize: 140, color: "A0A0A0" }} />
                                </td>
                            </tr>
                        </table>
                    </Row>
                </Container>
            </div>

            <Container>
                <Row style={{ marginTop: -70 }}>
                    <Card className='cards content mb-5'>
                        <table className='content-options content'>
                            <tr>
                                <td className='content-options rows left'>
                                    <Link to={'/citas'} className='link-primary'>
                                        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} />Volver a Citas
                                    </Link>
                                    <span className='ms-3' style={{ color: '#A0A0A0' }}>|</span><span className='ms-3'>Datos generales de la cita</span>

                                </td>
                                <td className='content-options rows right'>

                                </td>
                            </tr>
                        </table>

                        <img src='/map-demo.png' className='w-100'></img>
                    </Card>
                </Row>
            </Container>

            <Container>

                <Row>
                    <Col className='me-4'>

                        <Row>
                            <Card className='cards content mb-5'>
                                <table className='content-options content'>
                                    <tr>
                                        <td className='content-options rows left'>
                                            <span>Datos del servicio</span>

                                        </td>
                                        <td className='content-options rows right'>

                                        </td>
                                    </tr>
                                </table>

                                <Container className='mt-3 mb-3'>
                                    <Row>
                                        <Col xs={4} className='align-center-vertically'>
                                            Estado
                                        </Col>
                                        <Col>
                                            <Badge bg='success' className='me-2 content-table status' >Realizada</Badge>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col xs={4} className='align-center-vertically'>
                                            Encargado
                                        </Col>
                                        <Col>
                                            <img className='avatar-40 me-2' src='/avatar_secdevs.png'></img> Lucas Mancuso
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col xs={4} className='align-center-vertically'>
                                            Cliente
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Control type="text" id="textCustomer" disabled placeholder="" value='Tostado Cafe Club' />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col xs={4} className='align-center-vertically'>
                                            Tipo de servicio
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Control type="text" id="textCustomer" disabled placeholder="" value='Fumigación' />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col xs={4} className='align-center-vertically'>
                                            Duración
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Control type="text" id="textCustomer" disabled placeholder=""  value='120 minutos' />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col xs={4} className='align-center-vertically'>
                                            Monto a cobrar
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Control type="text" id="textCustomer" disabled placeholder="" value='$10.000' />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col xs={4} className='align-center-vertically'>
                                            Fecha
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Control type="text" id="textCustomer" disabled placeholder="" value='20/01/2023 10:00'/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Container>
                            </Card>
                        </Row>

                    </Col>
                    <Col className='ms-4'>
                        <Row>
                            <Card className='cards content mb-5'>
                                <table className='content-options content'>
                                    <tr>
                                        <td className='content-options rows left'>
                                            <span>Historial</span>

                                        </td>
                                        <td className='content-options rows right'>

                                        </td>
                                    </tr>
                                </table>

                                <Container className='mt-3 mb-3'>
                                    <Row className='p-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={4} className='align-center-vertically'>
                                            10 ENE - 9:56
                                        </Col>
                                        <Col>
                                            Cita creada
                                        </Col>
                                    </Row>

                                    <Row className='p-2 mt-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={4} className='align-center-vertically'>
                                            10 ENE - 12:34
                                        </Col>
                                        <Col>
                                            El cliente confirmó la fecha de la cita
                                        </Col>
                                    </Row>

                                    <Row className='p-2 mt-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={4} className='align-center-vertically'>
                                            20 ENE - 12:04
                                        </Col>
                                        <Col>
                                            Cita realizada
                                        </Col>
                                    </Row>

                                    <Row className='p-2 mt-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={4} className='align-center-vertically'>
                                            20 ENE - 13:00
                                        </Col>
                                        <Col>
                                            Oblea enviada
                                        </Col>
                                    </Row>

                                    <Row className='p-2 mt-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={4} className='align-center-vertically'>
                                            20 ENE - 14:04
                                        </Col>
                                        <Col>
                                            Factura enviada
                                        </Col>
                                    </Row>


                                </Container>
                            </Card>
                        </Row>

                    </Col>
                </Row>




                <Row>
                    <Col className='me-4'>

                        <Row>
                            <Card className='cards content mb-5'>
                                <table className='content-options content'>
                                    <tr>
                                        <td className='content-options rows left'>
                                            <span>Documentos fiscales</span>

                                        </td>
                                        <td className='content-options rows right'>

                                        </td>
                                    </tr>
                                </table>

                                <Container className='mt-3 mb-3'>
                                    <Row className='p-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={1} className='align-center-vertically'>
                                            <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 30 }}></FontAwesomeIcon>
                                        </Col>
                                        <Col xs={9} className='align-center-vertically'>
                                            <div>
                                                <p className='m-0'>Recibo</p>
                                                <p className='m-0' style={{ fontSize: 12 }}>20 ENE</p>
                                            </div>

                                        </Col>
                                        <Col xs={2} className='align-center-vertically middle'>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                                    <span style={{ marginRight: 10 }}><FontAwesomeIcon icon={faEllipsisV} /></span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faEye} style={{ marginRight: 10, marginLeft: 2 }} />Ver archivo</Dropdown.Item>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faDownload} style={{ marginRight: 10, marginLeft: 2 }} />Descargar archivo</Dropdown.Item>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faTrash} style={{ marginRight: 10, marginLeft: 2 }} />Eliminar</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Col>
                                    </Row>

                                    <Row className='p-2 mt-3' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={1} className='align-center-vertically'>
                                            <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 30 }}></FontAwesomeIcon>
                                        </Col>
                                        <Col xs={9} className='align-center-vertically'>
                                            <div>
                                                <p className='m-0'>Factura A 00001-000023</p>
                                                <p className='m-0' style={{ fontSize: 12 }}>20 ENE</p>
                                            </div>

                                        </Col>
                                        <Col xs={2} className='align-center-vertically middle'>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                                    <span style={{ marginRight: 10 }}><FontAwesomeIcon icon={faEllipsisV} /></span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faEye} style={{ marginRight: 10, marginLeft: 2 }} />Ver archivo</Dropdown.Item>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faDownload} style={{ marginRight: 10, marginLeft: 2 }} />Descargar archivo</Dropdown.Item>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faTrash} style={{ marginRight: 10, marginLeft: 2 }} />Eliminar</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Col>
                                    </Row>
                                </Container>
                            </Card>
                        </Row>

                    </Col>
                    <Col className='ms-4'>
                        <Row>
                            <Card className='cards content mb-5'>
                                <table className='content-options content'>
                                    <tr>
                                        <td className='content-options rows left'>
                                            <span>Obleas</span>

                                        </td>
                                        <td className='content-options rows right'>

                                        </td>
                                    </tr>
                                </table>

                                <Container className='mt-3 mb-3'>
                                <Row className='p-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                        <Col xs={1} className='align-center-vertically'>
                                            <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 30 }}></FontAwesomeIcon>
                                        </Col>
                                        <Col xs={9} className='align-center-vertically'>
                                            <div>
                                                <p className='m-0'>Certificado de fumigación</p>
                                                <p className='m-0' style={{ fontSize: 12 }}>20 ENE 2023 a 19 FEB 2023</p>
                                            </div>

                                        </Col>
                                        <Col xs={2} className='align-center-vertically middle'>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                                    <span style={{ marginRight: 10 }}><FontAwesomeIcon icon={faEllipsisV} /></span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faEye} style={{ marginRight: 10, marginLeft: 2 }} />Ver archivo</Dropdown.Item>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faDownload} style={{ marginRight: 10, marginLeft: 2 }} />Descargar archivo</Dropdown.Item>
                                                    <Dropdown.Item ><FontAwesomeIcon icon={faTrash} style={{ marginRight: 10, marginLeft: 2 }} />Eliminar</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Col>
                                    </Row>


                                </Container>
                            </Card>
                        </Row>

                    </Col>
                </Row>

            </Container>




            <Modal show={showSearchCustomerModal} size='lg' onHide={handleCloseSearchCustomerModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Buscar cliente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control type="text" id="" autoFocus placeholder="Buscar..." onChange={(event) => handleSearchCustomers(event)} />
                    {customers.length > 0 ? <p className='mt-4 mb-0'>Resultado de búsqueda:</p> : <span></span>}
                    <ListGroup className='mt-2'>
                        {customers.map((c, i) => (
                            <ListGroup.Item key={i} onClick={() => handleCustomerSelected(c.id, c.isBusiness)}>{c.isBusiness == true ? (<div><p className='m-0' style={{ fontSize: 12 }}>Persona jurídica</p><p className='m-0'></p>{c.cuit.length > 1 ? `CUIT ${c.cuit} - ` : ""}{c.legalName}</div>) : (<div><p className='m-0' style={{ fontSize: 12 }}>Persona física</p><p className='m-0'></p>{c.dni.length > 1 ? `DNI ${c.dni} - ` : ""}{c.surname.toUpperCase()}, {c.name}</div>)}</ListGroup.Item>
                        ))}
                    </ListGroup>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseSearchCustomerModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={() => handleShowNewCustomerDefendantModal(true)}>
                        Crear nuevo cliente
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showSearchDefendantModal} size='lg' onHide={handleCloseSearchDefendantModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Buscar contrario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control type="text" id="" autoFocus placeholder="Buscar..." onChange={(event) => handleSearchDefendants(event)} />
                    {defendants.length > 0 ? <p className='mt-4 mb-0'>Resultado de búsqueda:</p> : <span></span>}
                    <ListGroup className='mt-2'>
                        {defendants.map((c, i) => (
                            <ListGroup.Item key={i} onClick={() => handleDefendantSelected(c.id, c.isBusiness)}>{c.isBusiness == true ? (<div><p className='m-0' style={{ fontSize: 12 }}>Persona jurídica</p><p className='m-0'></p>{c.cuit.length > 1 ? `CUIT ${c.cuit} - ` : ""}{c.legalName}</div>) : (<div><p className='m-0' style={{ fontSize: 12 }}>Persona física</p><p className='m-0'></p>{c.dni.length > 1 ? `DNI ${c.dni} - ` : ""}{c.surname.toUpperCase()}, {c.name}</div>)}</ListGroup.Item>
                        ))}
                    </ListGroup>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseSearchDefendantModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={() => handleShowNewCustomerDefendantModal(false)}>
                        Crear nuevo contrario
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showLawerModal} onHide={handleCloseLawerModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Abogado contrario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className=''>
                        <Form.Text>Nombre</Form.Text>
                        <Form.Control type="text" id="lawerName" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Apellido</Form.Text>
                        <Form.Control type="text" id="lawerSurname" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>DNI</Form.Text>
                        <Form.Control type="text" id="lawerDNI" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Estudio</Form.Text>
                        <Form.Control type="text" id="lawerFirm" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Teléfono / Celular</Form.Text>
                        <Form.Control type="text" id="lawerPhone" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Correo electrónico</Form.Text>
                        <Form.Control type="text" id="lawerEmail" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Dirección</Form.Text>
                        <Form.Control type="text" id="lawerAddress" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Localidad</Form.Text>
                        <Form.Control type="text" id="lawerCity" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Provincia</Form.Text>
                        <Form.Control type="text" id="lawerProvince" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Código postal</Form.Text>
                        <Form.Control type="text" id="lawerPostalCode" placeholder="" />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseLawerModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={handleProcessLawerModal}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showSearchStudentModal} onHide={handleCloseSearchStudentModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Alumno</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className=''>
                        <Form.Text>Nombre</Form.Text>
                        <Form.Control type="text" id="studentName" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Text>Apellido</Form.Text>
                        <Form.Control type="text" id="studentSurname" placeholder="" />
                    </Form.Group>
                    <Form.Group className='mt-2 mb-2'>
                        <Form.Text>DNI</Form.Text>
                        <Form.Control type="text" id="studentDni" placeholder="" />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseLawerModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={handleProcessStudentModal}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}